import React from "react";
import * as Styled from "./styled";

import {
  Profile,
  ProfileHeader,
  ProfileImage,
  ProfileInitials,
  ProfileInfo,
  ProfileButtons,
  ApproveButton,
  RejectButton,
  ResumeButton,
  ProfileDetails,
} from './styled.jsx';
 
const ProfileComp = ({ profile }) => {
  const getInitials = (name) => {
    const initials = name.split(" ").map((n) => n[0]).join("");
    return initials.toUpperCase();
  };
  const viewResume = (url)=>{
    window.open(url, "_blank");
  }
  console.log("Profile Data is --------->",profile);
  return (
    <Profile>
      <Styled.ProfileHeader>
        {profile.imageUrl ? (
          <ProfileImage src={profile.imageUrl} alt="Profile"/ >
        ) : (
          <Styled.ProfileInitials>
            {getInitials(profile.name)}
          </Styled.ProfileInitials>
        )}
      </Styled.ProfileHeader>
      <Styled.ProfileInfo>
        <h2>{profile.name}</h2>
        <Styled.ProfileButtons>
          {/* <Styled.ApproveButton>Approve</Styled.ApproveButton> */}
          <Styled.RejectButton>View Report</Styled.RejectButton>
          <Styled.ResumeButton onClick={()=>{viewResume(profile.cvUrl)}}>View Resume</Styled.ResumeButton>
        </Styled.ProfileButtons>
        <Styled.ProfileDetails>
          <p>
            <strong>Contact No: </strong>
            {profile.contact}
          </p>
          <p>
            <strong>Email Address: </strong> {profile.email}
          </p>
          <p>
            <strong>Experience: </strong> {profile.exp}
          </p>
          <p>
            <strong>Salary: </strong> {profile.salary}
          </p>
          <p>
            <strong>Resume Score: </strong> {profile.score}%
          </p>
          <p>
            <strong>Assessment Score: </strong> {50}%
          </p>
        </Styled.ProfileDetails>
      </Styled.ProfileInfo>
    </Profile>
  );
};

export default ProfileComp;
